import React from "react";
import {
  GatsbyImage,
  IGatsbyImageData,
  ImageDataLike,
} from "gatsby-plugin-image";

type getGatsbyImageNodeProps = {
  image: IGatsbyImageData;
  alt: string;
  isContained?: boolean;
  lazyLoading?: boolean;
  offMain?: boolean;
  width?: string;
  height?: string;
};

export const getGatsbyImageNode = (
  image: IGatsbyImageData,
  alt: string,
  isContained: boolean = false,
  lazyLoading: boolean = true,
  offMain: boolean = true,
  width: string = "100%",
  height: string = "100%"
) => {
  return (
    <GatsbyImage
      image={image}
      alt={alt}
      loading={lazyLoading ? "lazy" : "eager"}
      style={{ width: width, height: height }}
      objectFit={isContained ? "contain" : "cover"}
      objectPosition="center center"
      decoding={offMain ? "async" : "sync"}
    />
  );
};